import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `template`);
        return response;
    } catch (e) { }
}


export async function getTemplate(id: string) {
    try {
        const response = await apiGet('core', `template/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function templateAdd(templateBody: any) {
    try {
        const response = await apiPost('core', `template`, templateBody);
        return response;
    } catch (e) { }
}

export async function templateUpdate(id: string, templateBody: any) {
    try {
        const response = await apiPut('core', `template/${id}`, templateBody);
        return response;
    } catch (e) { }
}

export async function templateRemove(id: any) {
    try {
        return await apiDelete('core', `template/${id}`);
    } catch (e) { }
}